export { HomeScreenContent as HomeScreenContentV2 } from './HomeScreenContentV2';
